<template>
  <div class="dashboard">
    <h2>回调查询</h2>
    <el-card shadow="hover">
      <callback-search 
      ref="callbackSearchCom"
    />
    </el-card>
  </div>
</template>

<script>
import CallbackSearch from '@/components/CallbackSearch.vue'

export default {
    components: {
      CallbackSearch
    },
    name: 'CallbackDatas',
    // 可以添加页面专属的逻辑
    data(){
      return {
      }
    },
    methods: {

    }
}
</script>

<style scoped>
.dashboard {
  padding: 20px;
}
</style>